import React from "react";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Paper from "@mui/material/Paper";
import LoginHeader from "./components/LoginHeader.js";
import SideNavigation from "./components/SideNavigation.js";
import { useEffect, useState } from "react";
import "./Spinner.css";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Table } from "react-bootstrap";
import { DatePicker } from "antd";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import { appInsights } from "./AppInsights";
import moment from "moment";
import { Link } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Paginator } from "primereact/paginator";
import { Dropdown } from "primereact/dropdown";
import "./table.css";
import { BiSolidCalendar } from "react-icons/bi";
import { buildAoa, downloadAoaAsXlsx, downloadAoaAsCsv, exportFilename } from "./utils/exportTable";
import AADHeader from "./components/AADHeader.js";
import dayjs from "dayjs";

/** Owner email / id on report rows varies by ESG module (e.g. Business Travel uses Owner, not email). */
function getRecordOwnerIdentifier(item, headers) {
  if (!item || typeof item !== "object") return "";
  const directCandidates = [item.email, item.Email, item.owner, item.Owner, item.userEmail, item.UserEmail];
  for (const c of directCandidates) {
    if (c != null && String(c).trim() !== "") return String(c).trim();
  }
  const ownerLikeKey = Object.keys(item).find((k) => {
    const kl = k.toLowerCase();
    return kl === "owner" || kl === "owneremail" || kl === "useremail" || kl === "email";
  });
  if (ownerLikeKey != null && item[ownerLikeKey] != null && String(item[ownerLikeKey]).trim() !== "") {
    return String(item[ownerLikeKey]).trim();
  }
  if (Array.isArray(headers)) {
    const ownerHeader = headers.find((h) => {
      if (h == null || h === "") return false;
      const hl = String(h).trim().toLowerCase();
      return hl === "owner" || hl === "owner email" || hl === "user email";
    });
    if (ownerHeader != null && item[ownerHeader] != null && String(item[ownerHeader]).trim() !== "") {
      return String(item[ownerHeader]).trim();
    }
  }
  return "";
}

/** Hide DateTime.MinValue / year-0001 placeholders that should never have been persisted. */
function formatReportHistoryCell(key, cell) {
  if (cell == null || cell === "") return cell;
  const keyLower = (key || "").toString().toLowerCase();
  const isDateCol = keyLower.includes("date") || keyLower.includes("period");
  if (!isDateCol) return cell;
  const raw = String(cell).trim();
  // 01/01/0001, 1/1/0001, 0001-01-01, etc.
  if (/^0?1[/.-]0?1[/.-]0001(\s|$)/.test(raw) || /^0001[-/]0?1[-/]0?1/.test(raw)) {
    return "—";
  }
  const parsed = dayjs(
    raw,
    ["DD/MM/YYYY", "D/M/YYYY", "MM/DD/YYYY", "M/D/YYYY", "YYYY-MM-DD", "DD-MM-YYYY HH:mm:ss", dayjs.ISO_8601],
    true,
  );
  if (parsed.isValid() && parsed.year() <= 1) {
    return "—";
  }
  return cell;
}

const dropdownItemTemplate = (option) => (
  <span className="form-dropdown-option-text" title={option.label}>
    {option.label}
  </span>
);

export default function Home() {
  const username = localStorage.getItem("userName");
  const urlSearchParams = new URLSearchParams(window.location.search);
  const slParam = urlSearchParams.get("sl");
  const esg = urlSearchParams.get("esg");
  const topic = urlSearchParams.get("topic") || "";
  const subtopic = urlSearchParams.get("subtopic") || "";
  var myHeaders = new Headers();
  myHeaders.append("username", username);
  myHeaders.append("sl", slParam);
  myHeaders.append("esg", esg);
  myHeaders.append("topic", topic);
  myHeaders.append("subtopic", subtopic);

  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };
  const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 768);

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setIsSidebarOpen(false); // Close sidebar on mobile
      } else {
        setIsSidebarOpen(true); // Open sidebar on larger screens
      }
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const [isLoading, setIsLoading] = useState(false);
  const [reporthistory, setReportHistory] = React.useState("");
  const [reporthistoryheader, setReportHistoryHeader] = React.useState("");
  const [owner, setOwner] = React.useState("");
  const [supplier, setSupplier] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [message, setMessage] = React.useState(false);
  const [startdate, setStartDate] = React.useState("");
  const [enddate, setEndDate] = React.useState("");
  const [sup, setSup] = React.useState("");
  const [own, setOwn] = React.useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedDate1, setSelectedDate1] = useState(null);
  const [dateFilterError, setDateFilterError] = useState("");
  const [globalSearch, setGlobalSearch] = useState("");
  const [allReportHistory, setAllReportHistory] = useState([]);
  const parseRecordDate = (value) => {
    if (!value) return null;
    const parsed = dayjs(value, ["DD/MM/YYYY", "D/M/YYYY", "YYYY-MM-DD", "MM/DD/YYYY", dayjs.ISO_8601], true);
    if (parsed.isValid()) return parsed;
    const fallback = dayjs(value);
    return fallback.isValid() ? fallback : null;
  };
  const getDateByKeyword = (item, keyword) => {
    const key = Object.keys(item || {}).find((k) => k.toLowerCase().includes(keyword) && k.toLowerCase().includes("date"));
    return key ? parseRecordDate(item[key]) : null;
  };
  const getAnyDate = (item) => {
    const key = Object.keys(item || {}).find((k) => k.toLowerCase().includes("date"));
    return key ? parseRecordDate(item[key]) : null;
  };

  const reset = async () => {
    setOwn("");
    setSup("");
    setSelectedDate(null);
    setSelectedDate1(null);
    setGlobalSearch("");
    setDateFilterError("");
    setReportHistory(allReportHistory);
    setPage(0);
  };
  // Handle the search of the item
  const applyFilters = () => {
    const parsedData = Array.isArray(allReportHistory) ? allReportHistory : [];
    const hasStartDate = selectedDate !== "" && selectedDate !== null;
    const hasEndDate = selectedDate1 !== "" && selectedDate1 !== null;

    // Validation: if either date is selected, both must be selected
    if (hasStartDate !== hasEndDate) {
      setDateFilterError("Please select both Start Date and End Date to filter by date.");
    } else {
      setDateFilterError("");
    }

    const hasSupplier = sup !== "";
    const hasOwner = own !== "";
    const hasGlobalSearch = globalSearch.trim() !== "";
    const globalSearchLower = globalSearch.trim().toLowerCase();
    const filterStart = hasStartDate ? dayjs(selectedDate).startOf("day") : null;
    const filterEnd = hasEndDate ? dayjs(selectedDate1).endOf("day") : null;

    if (filterStart && filterEnd && filterEnd.isBefore(filterStart)) {
      setDateFilterError("End Date cannot be earlier than Start Date.");
      setReportHistory(parsedData);
      setPage(0);
      return;
    }

    const filteredData = parsedData.filter((item) => {
      if (hasSupplier) {
        const itemSupplier = (item.SupplierName || item.supplier || "").toString().toLowerCase();
        if (itemSupplier !== sup.toLowerCase()) return false;
      }

      if (hasOwner) {
        const itemOwner = getRecordOwnerIdentifier(item, reporthistoryheader);
        if (itemOwner !== own) return false;
      }

      if (hasStartDate && hasEndDate && filterStart && filterEnd) {
        const itemStart = getDateByKeyword(item, "start");
        const itemEnd = getDateByKeyword(item, "end");
        const fallbackDate = getAnyDate(item);
        const effectiveStart = itemStart || itemEnd || fallbackDate;
        const effectiveEnd = itemEnd || itemStart || fallbackDate;

        if (!effectiveStart || !effectiveEnd) return false;
        if (effectiveStart.isBefore(filterStart)) return false;
        if (effectiveEnd.isAfter(filterEnd)) return false;
      }

      if (hasGlobalSearch) {
        const rowContainsSearch = Object.values(item || {}).some((value) => value?.toString().toLowerCase().includes(globalSearchLower));
        if (!rowContainsSearch) return false;
      }

      return true;
    });

    setReportHistory(filteredData);
    setPage(0);
  };
  useEffect(() => {
    applyFilters();
  }, [selectedDate, selectedDate1, sup, own, globalSearch, allReportHistory, reporthistoryheader]);

  async function fetchHistory() {
    setLoading(true);

    try {
      setIsLoading(true);
      const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}report-history-dynamic`, requestOptions);
      const data = await response.json();
      if (data.success == false) {
        setLoading(false);
      } else if (data.status == 400) {
        setLoading(false);
      } else {
        setLoading(false);
        setReportHistory(data.data.records);
        setAllReportHistory(data.data.records);
        const headers = data.data.headers;
        setReportHistoryHeader(headers);
        localStorage.setItem("report", JSON.stringify(data.data.records));
        setIsLoading(false);

        //Filter Unique Owner
        const uniqueOwner = new Set();
        const uniqueSupplier = new Set();
        const cdata = data.data.records;
        console.log(cdata);
        data.data.records.forEach((row) => {
          const oid = getRecordOwnerIdentifier(row, headers);
          if (oid) uniqueOwner.add(oid);
          // Check if SupplierName exists before adding
          if (row.SupplierName) {
            uniqueSupplier.add(row.SupplierName.toLowerCase());
          }
        });
        if (uniqueOwner.size === 0 && username && String(username).trim() !== "" && Array.isArray(data.data.records) && data.data.records.length > 0) {
          uniqueOwner.add(String(username).trim());
        }

        const distinctOwner = Array.from(uniqueOwner);
        setOwner(distinctOwner);
        const distinctSupplier = Array.from(uniqueSupplier);
        const capitalizedArray = distinctSupplier.map((value) => value.charAt(0).toUpperCase() + value.slice(1));
        setSupplier(capitalizedArray);
      }
    } catch (error) {
      setLoading(false);
      setIsLoading(false);
      console.error(error);
    }
  }
  useEffect(() => {
    appInsights.trackPageView();
    fetchHistory();
  }, []);

  const handleDateChange = (date) => {
    // Clear end date only when the new start date is after it.
    if (date && selectedDate1 && dayjs(date).startOf("day").isAfter(dayjs(selectedDate1).startOf("day"))) {
      setSelectedDate1(null);
    }
    setDateFilterError("");
    setSelectedDate(date);
  };

  const handleDateChange1 = (date) => {
    if (date && selectedDate && dayjs(date).isBefore(dayjs(selectedDate), "day")) {
      setDateFilterError("End Date cannot be earlier than Start Date.");
      return;
    }
    setDateFilterError("");
    setSelectedDate1(date);
  };

  const CustomDatePickerInput = ({ value, onClick }) => (
    <div className="date-input-container" onClick={onClick}>
      <input type="text" value={value} readOnly placeholder="Start date" className="date-input reporthistory-date" />
      <img src="assets/img/reports/calendar.png" className="calendar-icon" />
    </div>
  );
  const CustomDatePickerInput1 = ({ value, onClick }) => (
    <div className="date-input-container" onClick={onClick}>
      <input type="text" value={value} readOnly placeholder="End date" className="date-input reporthistory-date" />
      <img src="assets/img/reports/calendar.png" className="calendar-icon" />
    </div>
  );
  const onPageChange = (event) => {
    setPage(event.page);
    setRowsPerPage(event.rows); // Update rows per page
  };
  const renderHeader = () => {
    const loginType = localStorage.getItem("loginType");
    if (loginType === "AAD") {
      return <AADHeader toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} heading="" />;
    }
    return <LoginHeader toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} heading="" />;
  };
  const supplierColumnIndex = Array.isArray(reporthistoryheader) ? reporthistoryheader.findIndex((header) => header?.toString().trim().toLowerCase() === "supplier") : -1;
  const ownerColumnIndex = Array.isArray(reporthistoryheader)
    ? reporthistoryheader.findIndex((header) => {
        const label = (header ?? "")
          .toString()
          .trim()
          .replace(/_/g, " ")
          .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
          .replace(/\s+/g, " ")
          .trim()
          .toLowerCase();
        return label === "owner";
      })
    : -1;
  const formatHeaderLabel = (header) => {
    const label = (header ?? "").toString().trim();
    if (!label) return "";
    return label
      .replace(/_/g, " ")
      .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
      .replace(/\s+/g, " ")
      .trim();
  };
  const baseCellStyle = {
    width: "140px",
    minWidth: "140px",
    maxWidth: "140px",
    whiteSpace: "normal",
    overflow: "visible",
    textOverflow: "clip",
    wordBreak: "break-word",
    padding: "8px 10px",
    lineHeight: "18px",
  };
  const supplierCellStyle = {
    ...baseCellStyle,
    width: "170px",
    minWidth: "170px",
    maxWidth: "170px",
  };
  const ownerCellStyle = {
    ...baseCellStyle,
    width: "240px",
    minWidth: "240px",
    maxWidth: "240px",
    whiteSpace: "normal",
    overflow: "visible",
    textOverflow: "clip",
    wordBreak: "break-word",
  };
  const baseHeaderCellStyle = {
    ...baseCellStyle,
    whiteSpace: "normal",
    overflow: "visible",
    textOverflow: "clip",
    lineHeight: "20px",
    wordBreak: "break-word",
  };
  const supplierHeaderCellStyle = {
    ...baseHeaderCellStyle,
    width: "170px",
    minWidth: "170px",
    maxWidth: "170px",
  };
  const ownerHeaderCellStyle = {
    ...baseHeaderCellStyle,
    width: "240px",
    minWidth: "240px",
    maxWidth: "240px",
  };
  const getColumnStyle = (columnIndex, type = "body") => {
    if (type === "header") {
      if (columnIndex === ownerColumnIndex) return ownerHeaderCellStyle;
      if (columnIndex === supplierColumnIndex) return supplierHeaderCellStyle;
      return baseHeaderCellStyle;
    }
    if (columnIndex === ownerColumnIndex) return ownerCellStyle;
    if (columnIndex === supplierColumnIndex) return supplierCellStyle;
    return baseCellStyle;
  };
  // Export what the user currently sees: the filtered rows, formatted like the
  // table (same header labels, same cell formatting). Header labels come from
  // the backend payload; cells go through formatReportHistoryCell.
  const exportHistory = (kind) => {
    const aoa = buildAoa(
      Array.isArray(reporthistoryheader) ? reporthistoryheader.map(formatHeaderLabel) : [],
      reporthistory,
      formatReportHistoryCell
    );
    const name = exportFilename(["report-history", slParam, topic || esg], kind);
    if (kind === "xlsx") downloadAoaAsXlsx(aoa, name);
    else downloadAoaAsCsv(aoa, name);
  };

  return (
    <div id="wrapper">
      <div>
        {loading && (
          <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={true}>
            <CircularProgress color="inherit" />
          </Backdrop>
        )}
      </div>
      {renderHeader()}
      <SideNavigation isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      <div id="page-content-wrapper" className={isSidebarOpen ? "page-content-wrapper-pd-0" : "page-wrapper"}>
        <div className="formpd report-history-page">
          <div className="flex report-history-header-row">
            <div className="col-md-9 report-history-header-col">
              <div Class="steps__containt-hader">
                <h3 class="title">Report History</h3>
                <div role="presentation">
                  <Breadcrumbs aria-label="breadcrumb" separator={<NavigateNextIcon fontSize="small" />}>
                    <Link to="/allconfiguration" underline="hover" color="inherit" className="breadcrumbs-font">
                      Configuration
                    </Link>
                    <Typography color="text.primary">Report History</Typography>
                  </Breadcrumbs>
                </div>
              </div>
            </div>
            <div className="col-md-3 report-history-header-col">
              <div Class="steps__containt-hader btalignleft">
                <button className="btn btn-search" onClick={reset}>
                  Reset filter
                </button>
                <button
                  className="btn btn-search"
                  style={{ marginLeft: 8 }}
                  disabled={!Array.isArray(reporthistory) || reporthistory.length === 0}
                  title="Download the rows currently shown (filters applied) as Excel"
                  onClick={() => exportHistory("xlsx")}
                >
                  Export Excel
                </button>
                <button
                  className="btn btn-search"
                  style={{ marginLeft: 8 }}
                  disabled={!Array.isArray(reporthistory) || reporthistory.length === 0}
                  title="Download the rows currently shown (filters applied) as CSV"
                  onClick={() => exportHistory("csv")}
                >
                  Export CSV
                </button>
              </div>
            </div>
          </div>
          <div>{message}</div>
          <div className="flex mb-10 report-history-filters-row">
            <div className="col-md-2 report-history-filter-col">
              <DatePicker
                id="startDate"
                className="calendar-form1"
                value={selectedDate}
                onChange={handleDateChange}
                placeholder="Start Date"
                format={"DD/MM/YYYY"}
                suffixIcon={<BiSolidCalendar />}
                disabledDate={(current) => selectedDate1 && current && current > dayjs(selectedDate1).endOf("day")}
              />
            </div>
            <div className="col-md-2 report-history-filter-col">
              <DatePicker
                id="endDate"
                value={selectedDate1}
                className="calendar-form1"
                onChange={handleDateChange1}
                placeholder="End Date"
                // disabled={!isToDateEnabled}
                showToday={false}
                format={"DD/MM/YYYY"}
                suffixIcon={<BiSolidCalendar />}
                disabledDate={(current) => selectedDate && current && current < dayjs(selectedDate).startOf("day")}
              />
            </div>
            <div className="col-md-2 report-history-filter-col">
              <Dropdown
                className="form-control wd-100"
                value={sup || null}
                onChange={(e) => setSup(e.value || "")}
                options={supplier && supplier.map((datas) => ({ label: datas, value: datas }))}
                placeholder="Supplier"
                filter
                filterPlaceholder="Search supplier"
                showClear
                appendTo="self"
                panelClassName="form-dropdown-panel"
                itemTemplate={dropdownItemTemplate}
              />
            </div>
            <div className="col-md-4 report-history-filter-col report-history-filter-col-owner">
              <Dropdown
                className="form-control wd-100"
                value={own || null}
                onChange={(e) => setOwn(e.value || "")}
                options={owner && owner.map((datas) => ({ label: datas, value: datas }))}
                placeholder="Owner"
                filter
                filterPlaceholder="Search owner"
                showClear
                appendTo="self"
                panelClassName="form-dropdown-panel"
                itemTemplate={dropdownItemTemplate}
              />
            </div>

            <div className="col-md-2 report-history-filter-col report-history-filter-col-search">
              <div className="report-history-search-wrap">
                <img src="assets/img/search.png" className="search-i-reporthistory" />
                <input
                  type="text"
                  className="form-control report-history-search-input"
                  value={globalSearch}
                  onChange={(e) => setGlobalSearch(e.target.value)}
                  placeholder="Search"
                />
              </div>
            </div>
          </div>
          {dateFilterError && (
            <div className="report-history-error" style={{ marginBottom: "12px" }}>
              <Typography variant="body2" color="error" component="span">
                {dateFilterError}
              </Typography>
            </div>
          )}
          <div className="report-history-table-wrap">
            <TableContainer component={Paper}>
              <Table className="report-history-data-table" sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    {reporthistoryheader &&
                      reporthistoryheader.map((row, index) => (
                        <TableCell key={index} align="left" style={getColumnStyle(index, "header")} title={formatHeaderLabel(row)}>
                          {formatHeaderLabel(row)}
                        </TableCell>
                      ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                        {reporthistory &&
                    reporthistory.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, rowIndex) => (
                      <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }} key={rowIndex}>
                        {Object.entries(row).map(([key, cell], cellIndex) => {
                          const display = formatReportHistoryCell(key, cell);
                          return (
                          <TableCell key={cellIndex} align="left" component="th" scope="row" style={getColumnStyle(cellIndex)} title={display != null ? String(display) : ""}>
                            {display}
                          </TableCell>
                          );
                        })}
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
            <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
              <Paginator first={page * rowsPerPage} rows={rowsPerPage} totalRecords={reporthistory.length} rowsPerPageOptions={[10, 20, 25, 50]} onPageChange={onPageChange} template="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink" currentPageReportTemplate="{first} to {last} of {totalRecords}" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
